// Servicio para gestionar notificaciones push
class PushNotificationService {
    constructor() {
        this.listeners = [];
        this.notifications = [];
    }

    // Suscribirse a nuevas notificaciones
    subscribe(callback) {
        this.listeners.push(callback);
        return () => {
            this.listeners = this.listeners.filter(cb => cb !== callback);
        };
    }

    // Agregar una nueva notificación
    addNotification(notificacion) {
        this.notifications.push(notificacion);
        this.listeners.forEach(callback => callback(notificacion));
    }

    // Obtener todas las notificaciones
    getNotifications() {
        return [...this.notifications];
    }

    // Remover una notificación
    removeNotification(id) {
        this.notifications = this.notifications.filter(n => n.id !== id);
    }
}

export default new PushNotificationService();

